import React, { useEffect, useRef, useState } from "react";

// Style
import "./DeboundceInput.scss";

// Components
import Img from "components/Img";
import Loader from "components/UiKit/Loader";
import { DebounceInput } from "react-debounce-input";
import ErrorBoundary from "components/ErrorBoundary";

// Classes
import clsx from "clsx";

// Interface
interface IDebounceInput {
  suggest?: any;
  label?: string;
  value?: string;
  style?: object;
  loading?: boolean;
  Children?: any;
  isWhite?: boolean;
  className?: string;
  message?: string;
  callback?: any;
  minLength?: number;
  isSuggest?: boolean;
  placeholder?: string;
  onChange?: any;
  isLeftIcon?: boolean;
  isRightIcon?: boolean;
  leftIconAction?: any;
  typeMessage?: string;
  recentList?: string[];
  rightIconAction?: any;
  debounceTimeout?: number;
  classNameWrapper?: string;
  onKeyDown?: React.KeyboardEventHandler;
}

const Container: React.FC<IDebounceInput> = (props) => {
  const {
    style,
    label,
    message,
    loading,
    callback,
    Children,
    onChange,
    isSuggest,
    className,
    minLength,
    onKeyDown,
    isLeftIcon,
    recentList,
    placeholder,
    typeMessage,
    isRightIcon,
    suggest = [],
    leftIconAction,
    isWhite = false,
    rightIconAction,
    debounceTimeout,
    classNameWrapper
  } = props;

  const ref = useRef(null);
  const [val, setVal] = useState("");
  const wrapRef = useRef<HTMLInputElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const inputDebounce: HTMLInputElement | null = document.querySelector(".input-debounce__list");

  const handleClickOutside = (event: any) => {
    if (
      wrapRef.current !== event.target.closest(".input-debounce")
      && inputDebounce
    ) {
      inputDebounce.style.display = "none";
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [inputDebounce]);

  const handlerClick = (event: any) => {
    const element = event?.target as HTMLInputElement;
    const attributeValue: string = element?.getAttribute("data-value") || "";

    callback && callback(attributeValue);
    setVal(attributeValue);
  };

  const handlerClickRightIcon = () => {
    rightIconAction && rightIconAction();

    // @ts-ignore
    ref.current.value = "";
    setVal("");
  };

  const cn = clsx(
    "input-debounce__list",
    suggest?.length ? "input-debounce__list--active" : ""
  );

  const cnMessage = clsx(
    "input-debounce__message",
    !!typeMessage ? `input-debounce__message--${typeMessage}` : ""
  );

  const cnInput = clsx(
    "input-debounce__input",
    className ? className : ""
  );

  const cnWrapper = clsx(
    "input-debounce",
    classNameWrapper ? classNameWrapper : ""
  );

  const iconLeft = isWhite ? "searchSvg" : "search";

  return (
    <ErrorBoundary>
      <div
        ref={wrapRef}
        className={cnWrapper}
      >
        {!!label &&
          <div className="input-debounce__label">
            {label}
          </div>
        }
        <div className="input-debounce__wrapper">
          <div className="relative">
            {!!isLeftIcon && (
              <div
                onClick={leftIconAction}
                className="input-debounce__icon-left-wrapper"
              >
                <Img isSvg={isWhite} name={iconLeft} alt="Icon left" className="input-debounce__icon-left" />
              </div>
            )}
            <DebounceInput
              type="text"
              value={val}
              style={style}
              inputRef={ref}
              onChange={onChange}
              className={cnInput}
              onKeyDown={onKeyDown}
              minLength={minLength}
              placeholder={placeholder}
              debounceTimeout={debounceTimeout}
            />
            {!!isRightIcon && (
              <div
                onClick={handlerClickRightIcon}
                className="input-debounce__icon-right-wrapper"
              >
                <Img name="cross" alt="Icon right" className="input-debounce__icon-right" />
              </div>
            )}
          </div>

          {!!recentList?.length && <div className="input-debounce__recent flex flex-ai-start">
            <div className="flex flex-wrap flex-ai-start">
              <p className="input-debounce__recent-title">Last search: </p>
              {recentList?.map((item: string, i: number) => {
                const cnRecentItem = clsx(
                  "input-debounce__recent-item",
                  recentList?.length - 1 !== i ? "input-debounce__recent-item--active" : ""
                );
                return <p
                  data-value={item}
                  key={`${item}__${i}`}
                  onClick={handlerClick}
                  className={cnRecentItem}
                >
                  {/*{`${item}${recentList?.length - 1 !== i ? ',' : ''}`}*/}
                  {item}
                </p>;
              })}
            </div>
          </div>}
        </div>

        {message &&
          <p className={cnMessage}>
            {message}
          </p>
        }

        {!!isSuggest && <div
          ref={inputRef}
          className={cn}
        >
          {loading ?
            <div className="input-debounce__loader">
              <Loader type="small" />
            </div>
            :
            suggest?.length
              ? suggest?.map((item: any, i: number) => {
                if (!!Children) {
                  return <Children
                    {...item}
                    key={`${item?.name}_${i}`}
                  />;
                } else {
                  return <div
                    key={`${item?.name}_${i}`}
                    className="input-debounce__default-value"
                  >
                    {item.name}
                  </div>;
                }
              })
              : <p className="input-debounce__dropdown-text">
                Unfortunately nothing has been found
              </p>}
        </div>}
      </div>
    </ErrorBoundary>
  );
};

export default Container;